
<div class="container col-xxl-8 px-4 py-5 landing-content" >
    <div class="row align-items-center g-5 py-5">
  
        <h1 class="display-5 fw-bold text-body-emphasis lh-1 mb-3">Copyright Notice</h1>
        <div class="row align-items-center g-5">

            <h2 class="display-5 lh-1 mb-3">1. Introduction</h2>
            <p>The copyright for this platform and software belongs to Canada GPS.</p> 

            <h2 class="display-5 lh-1 mb-3">2. Permitted Use</h2>
            <p>Users may not copy, modify, or distribute any content without authorization. All rights are reserved by the copyright holder.</p> 

            <h2 class="display-5 lh-1 mb-3">3. Infringement Notice</h2>
            <p>If you notice any copyright infringement, please contact us immediately, and we will take appropriate action.</p> 

      </div>

    </div>
  </div>